import React, {Component} from 'react'

class UserListItem extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        let user = this.props.user;

        return <li>{user.nick}</li>;
    }
}

export default UserListItem;


// WEBPACK FOOTER //
// ./src/components/base/UserListItem/index.js